module.exports = __webpack_public_path__ + "img/DAY5-3.f3ae5ff7.jpg";